import React, { useEffect } from 'react';
import './App.sass';
import '@ant-design/v5-patch-for-react-19';
import { BrowserRouter, Routes, Route } from 'react-router';
import { useStore } from './providers/StoreProvider';
import { fetchReferralLink, TG } from '@/shared/api/api';
import { getDevice } from '@/shared/utils/window';

import { GamePage } from '@/pages/GamePage';
import { Menu } from '@/widgets/menu/Menu';
import { MenuPage } from '@/pages/MenuPage';
import { RatingPage } from '@/pages/RatingPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { TrackerPage } from '@/pages/TrackerPage';
import { LuckyPage } from '@/pages/LuckyPage';
import { TrainingPage } from '@/pages/TrainingPage';
import { TeamPage } from '@/pages/team/TeamPage';
import { TeamsPage } from '@/pages/team/TeamsPage';
import { TeamCreatePage } from '@/pages/team/TeamCreatePage';
import { TeamEditPage } from '@/pages/team/TeamEditPage';
import { InventoryPage } from '@/pages/InventoryPage';
import { ForecastPage } from '@/pages/forecast/ForecastPage';
import { SetForecastPage } from '@/pages/forecast/SetForecastPage';
import {Modals} from "@/entities/modals/ui/Modals";
import {QuestsPage} from "@/pages/QuestsPage";

declare global {
    interface Window {
      Telegram: any;
    }
}

const App = () => {
    const { userStore,teamStore,inventoryStore} = useStore();

    const device =  getDevice();

    if(TG){
        // TG.expand();
        if (typeof TG.requestFullscreen === "function") {
            if(device == 'mobile'){
                TG.requestFullscreen?.();
            }
        }
        TG.ready();
        TG.isClosingConfirmationEnabled = true;
        if (typeof TG.disableVerticalSwipes === "function") {
            TG.disableVerticalSwipes();
        }
    }

    useEffect(()=>{
        const fetchData = async() =>{
            await userStore.initUser();
            await userStore.getGameInfo();
            await teamStore.getMyTeam();
            const link = await fetchReferralLink();
            if(link.success){
                userStore.referralLink = link.data;
            }
            await inventoryStore.getInventoryLimits();
            await inventoryStore.getInventory();

        }
        fetchData();

    },[]);

  return (
    <div className={device} style={{height: '100%'}}>
      <BrowserRouter>
          <Routes>
              <Route index element={ <GamePage/>} />
              <Route path={'/menu'} element={ <MenuPage/>} />
              <Route path={'/menu/tracker'} element={ <TrackerPage/>} />
              <Route path={'/menu/lucky'} element={ <LuckyPage/>} />
              <Route path={'/menu/training'} element={ <TrainingPage/>} />
              <Route path={'/menu/inventory'} element={ <InventoryPage/>} />
              <Route path={'/menu/quests'} element={ <QuestsPage/>} />

              <Route path={'/menu/teams'} element={ <TeamsPage/>} />
              <Route path={'/team'} element={ <TeamPage/>} />
              <Route path={'/team-create'} element={ <TeamCreatePage/>} />
              <Route path={'/team-edit'} element={ <TeamEditPage/>} />

              <Route path={'/menu/forecast'} element={ <ForecastPage/>} />
              <Route path={'/forecast-set'} element={ <SetForecastPage/>} />

              <Route path={'/rating'} element={ <RatingPage/>} />
              <Route path={'/profile'} element={ <ProfilePage/>} />
          </Routes>
          <Menu/>
          <Modals/>
      </BrowserRouter>
    </div>
  );
};

export default App;
